/**
 * Estrae il nome della categoria "child" (livello 3) da un `categoryPath` salvato
 * dentro `product.customization_options`.
 *
 * Retrocompatibile: alcuni prodotti salvati prima del fix hanno `child` come
 * oggetto `{name, slug}` invece che come stringa. Ritorna sempre una stringa
 * (o `null` se non presente).
 */
export const getChildCategoryName = (categoryPath) => {
  const child = categoryPath?.child;
  if (!child) return null;
  if (typeof child === 'string') return child;
  if (typeof child === 'object') return child.name || child.slug || null;
  return null;
};

/**
 * Estrae lo slug della categoria "child" (per link/deep-link). Ritorna null se
 * non disponibile (es. prodotti vecchi con solo il nome salvato).
 */
export const getChildCategorySlug = (categoryPath) => {
  const child = categoryPath?.child;
  if (!child) return null;
  if (typeof child === 'object') return child.slug || null;
  return categoryPath?.childSlug || null;
};
